import React from 'react';
import PropTypes from 'prop-types';
import getContent from '../util/landingPageConfig';

import DocumentHeader from '../components/DocumentHeader';
import {LandingIntro} from '../components/LandingIntro';
import {TestimonialSection} from '../components/TestimonialSection';
import {ProductOverview} from '../components/ProductOverview';

export const CustomLandingPage = (props) => {
  const {
    socialThumbnail,
    socialDescription,
    metaDescription,
    leftHeroComponent,
    rightHeroComponent,
    id,
    landingLeftWidthClass,
  } = props;

  const content = getContent(id);

  return (
    <div className="CustomLandingPage bg-white">
      <DocumentHeader
        title={content.pageTitle}
        noindex={content.noindex}
        socialDescription={socialDescription}
        metaDescription={metaDescription}
        imgPath={socialThumbnail}
      />
      <LandingIntro
        lead={content.landingHeader}
        heading={content.landingSub}
        ctaText={content.landingCtaText}
        ctaUrl={content.landingCtaUrl}
        leftHeroComponent={leftHeroComponent}
        rightHeroComponent={rightHeroComponent}
        leftWidthClass={landingLeftWidthClass}
      />
      <ProductOverview
        lead={content.productOverview.lead}
        heading={content.productOverview.heading}
        products={Object.values(content.productOverview.productsList)}
      />
      <TestimonialSection />
    </div>
  );
};

CustomLandingPage.propTypes = {
  socialThumbnail: PropTypes.string.isRequired,
  leftHeroComponent: PropTypes.node,
  rightHeroComponent: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  landingLeftWidthClass: PropTypes.string,
};

CustomLandingPage.defaultProps = {
  leftHeroComponent: () => {},
  landingLeftWidthClass: 'w-full',
};

export default CustomLandingPage;
